module.exports = __webpack_public_path__ + "media/images/countryrect/al-a38fb37fbf064c1ebb7e46a79d0a1028.svg";